function init (section) {
  const tablist = section.querySelectorAll('[role="tablist"]')[0];
  const tabs = section.querySelectorAll('[role="tab"]');
  const panels = section.querySelectorAll('[role="tabpanel"]');

  const keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    enter: 13,
    space: 32
  };

  // Add or subtract depending on key pressed
  const direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1
  };

  // Attach event listener
  tabs.forEach((tab, index) => {
    tab.addEventListener('keydown', keydownEventListener);
    tab.index = index;
  });

  // Handle keydown on tabs
  function keydownEventListener (event) {
    const key = event.keyCode;

    switch (key) {
      case keys.end:
        focusLastTab();
        event.preventDefault();
        break;
      case keys.home:
        focusFirstTab();
        event.preventDefault();
        break;
      case keys.up:
      case keys.down:
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.enter:
      case keys.space:
        activateTab(event.target);
        event.preventDefault();
        break;
    }
  }

  // When a tablist aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  function determineOrientation (event) {
    const key = event.keyCode;
    const vertical = tablist.getAttribute('aria-orientation') === 'vertical';
    let proceed = false;
    if (vertical) {
      if (key === keys.up || key === keys.down) {
        // Up and down are in keydown
        // because we need to prevent page scroll
        event.preventDefault();
        proceed = true;
      }
    } else {
      if (key === keys.left || key === keys.right) {
        proceed = true;
      }
    }

    if (proceed) {
      switchTabOnArrowPress(event);
    }
  }

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  function switchTabOnArrowPress (event) {
    const pressed = event.keyCode;

    if (direction[pressed]) {
      const target = event.target;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        } else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        } else if (pressed === keys.right || pressed === keys.down) {
          focusFirstTab();
        }
      }
    }
  }

  // Activates any given tab panel
  function activateTab (tab, setFocus) {
    setFocus = setFocus || true;
    // Deactivate all other tabs
    deactivateTabs();

    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    // Get the value of aria-controls (which is an ID)
    const controls = tab.getAttribute('aria-controls');

    $(tab).addClass('active');
    $('#' + controls).show();
    if ($('#' + controls).hasClass('fade')) {
      $('#' + controls).addClass('in');
    }

    // Set focus when required
    if (setFocus) {
      tab.focus();
    }
  }

  // Deactivate all tabs and tab panels
  function deactivateTabs () {
    for (let index = 0; index < tabs.length; index++) {
      tabs[index].setAttribute('tabindex', '-1');
      tabs[index].setAttribute('aria-selected', 'false');
      tabs[index].classList.remove('active');
      const controls = tabs[index].getAttribute('aria-controls');

      // added a condition to make the tab content visible when space/enter is pressed
      if ($('#' + controls).hasClass('in')) {
        $('#' + controls).removeClass('in');
      }
    }

    for (let index = 0; index < panels.length; index++) {
      $(panels[index]).hide();
    }
  }

  function focusFirstTab () {
    tabs[0].focus();
  }

  function focusLastTab () {
    tabs[tabs.length - 1].focus();
  }
}

export default init;
